import React, { useState } from 'react';
import './Footer.css';
import PolicyPopup from './PolicyPopup';
import { privacyPolicy } from '../data/privacyPolicy';
import { legalTerms } from '../data/legalTerms';
import { useTracking } from '../hooks/useTracking';

const Footer = () => {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const { trackLinkClick } = useTracking();

  const handlePolicyClick = (policyType) => {
    trackLinkClick('policy_view', { policyType });
    if (policyType === 'privacy') {
      setShowPrivacyPolicy(true);
    } else {
      setShowTerms(true);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4>Important Links</h4>
          <nav>
            <a href="#" onClick={(e) => {
              e.preventDefault();
              handlePolicyClick('privacy');
            }}>Privacy Policy</a>
            <a href="#" onClick={(e) => {
              e.preventDefault();
              handlePolicyClick('terms');
            }}>Terms of Service</a>
            <a href="mailto:Admin@aroundu.co.za">Contact Us</a>
          </nav>
        </div>
        
        <div className="footer-section security-badge" style={{ flex: '2' }}>
          <a 
            href="https://www.watchdogscyber.co.za/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="security-link"
          >
            <p>Powered & Protected by: </p>
            <img 
              src="/images/watchdogs-logo.png" 
              alt="Watchdogs Cyber Security" 
              className="security-logo"
              style={{ width: '200px', height: 'auto' }}
            />
          </a>
        </div>
      </div>
      
      {showPrivacyPolicy && (
        <PolicyPopup
          title="Privacy Policy"
          content={privacyPolicy}
          onClose={() => setShowPrivacyPolicy(false)}
        />
      )}
      
      {showTerms && (
        <PolicyPopup
          title="Legal Terms"
          content={legalTerms}
          onClose={() => setShowTerms(false)}
        />
      )}
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} AroundU. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer; 